import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "p-1" };
const _hoisted_2 = {
    key: 0,
    class: "text-overview"
};
const _hoisted_3 = {
    key: 1,
    class: "text-overview"
};
const _hoisted_4 = {
    key: 2,
    class: "d-flex flex-row gap-16px"
};
const _hoisted_5 = { class: "d-flex flex-column flex-grow-1 gap-16px" };
import UserLastModified from '../components/UserLastModified.vue';
import ValidateModal from '../components/ValidateModal.vue';
import TypeAMuseumPremialita from '../components/TypeAMuseumPremialita.vue';
import TypeBMuseumPremialita from '../components/TypeBMuseumPremialita.vue';
import { useToast } from 'vue-toast-notification';
import { ref, onBeforeMount } from 'vue';
import { container as WidgetContainerModal, openModal } from "jenesius-vue-modal";
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-toast-notification/dist/theme-sugar.css';
import 'vue-loading-overlay/dist/css/index.css';
export default /*@__PURE__*/ _defineComponent({
    __name: 'editRoute',
    props: {
        campaignId: { type: String },
        museumId: { type: String },
        router: { type: Object },
        baseUrl: { type: String },
        totals: { type: String },
    },
    emits: ['status'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const $toast = useToast();
        const router = ref(props.router);
        const token = ref('');
        const isLoading = ref(false);
        const getError = ref(null);
        const status = ref('');
        const updatedByName = ref('');
        const updatedAt = ref('');
        const validateText = ref([]);
        const document = ref({});
        const onShowModal = () => {
            openModal(ValidateModal, { modalTitle: 'Avvertimento', modalContent: validateText.value });
        };
        const handleGoBack = () => {
            router.value.go(-1);
        };
        const fetchDataById = async () => {
            isLoading.value = true;
            try {
                const response = await axios.get(`${props.baseUrl}/v1/private/museums/${props.museumId}`, {
                    headers: { Authorization: `Bearer ${token.value}`, 'Accept-Language': '' }
                });
                document.value = { ...response.data };
            }
            catch (err) {
                console.error(err);
                getError.value = true;
            }
            finally {
                isLoading.value = false;
            }
        };
        onBeforeMount(() => {
            console.log('campaignId', props.campaignId);
            const data = localStorage.getItem('mi_cms-tokens');
            if (data)
                token.value = JSON.parse(data).access;
            fetchDataById();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isLoading.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                        _createVNode(_unref(Loading), {
                            active: isLoading.value,
                            "onUpdate:active": _cache[0] || (_cache[0] = ($event) => ((isLoading).value = $event)),
                            "can-cancel": false,
                            "is-full-page": true,
                            color: "#2D489D",
                            loader: "dots"
                        }, null, 8, ["active"])
                    ]))
                    : (getError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "No data to display"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                (document.value.ticketingMode === 'museum')
                                    ? (_openBlock(), _createBlock(TypeAMuseumPremialita, {
                                        key: document.value.activities,
                                        baseUrl: props.baseUrl,
                                        token: token.value,
                                        totals: __props.totals,
                                        campaignId: props.campaignId,
                                        museumId: props.museumId,
                                        activities: document.value.activities,
                                        visitTypes: document.value.visitTypes,
                                        onOnUpdate: fetchDataById
                                    }, null, 8, ["baseUrl", "token", "totals", "campaignId", "museumId", "activities", "visitTypes"]))
                                    : (_openBlock(), _createBlock(TypeBMuseumPremialita, {
                                        key: props.campaignId,
                                        baseUrl: props.baseUrl,
                                        token: token.value,
                                        campaignId: props.campaignId,
                                        museumId: props.museumId,
                                        activities: document.value.activities || [],
                                        onOnUpdate: fetchDataById
                                    }, null, 8, ["baseUrl", "token", "campaignId", "museumId", "activities"]))
                            ]),
                            _createElementVNode("div", null, [
                                _createVNode(UserLastModified, {
                                    "updated-by": updatedByName.value,
                                    "updated-at": updatedAt.value
                                }, null, 8, ["updated-by", "updated-at"])
                            ])
                        ])),
                _createVNode(_unref(WidgetContainerModal))
            ]));
        };
    }
});
